import { useContext } from 'react'

import AuthGuestContext from 'contexts/AuthGuestContext'

const useAuthGuest = () => {
  const context = useContext(AuthGuestContext)

  if (context === undefined) {
    throw new Error(
      'useAuthGuest must be used within AuthGuestContext.Provider',
    )
  }

  return {
    company: context.company,
    companyId: context.companyId,
    guestModule: context.guestModule,
    homeRoute: context.homeRoute,
    linkInvalid: context.linkInvalid,
    loadCompany: context.loadCompany,
    loadOut: context.loadOut,
    loaded: context.loaded,
    organizationSlug: context.organizationSlug,
    portalToken: context.portalToken,
    setUser: context.setUser,
    user: context.user,
  }
}

export default useAuthGuest
